module.exports = __webpack_public_path__ + "img/tour-16.586a87dc.png";